import { Button } from "@mui/material";
import React from "react";
import noteSearchImg from "../images/note-search.svg";
import arrow_btn from "../images/arrow_btn.svg";
import { useNavigate } from "react-router-dom";
import CircleRightTop from "../images/EllipseTeamTopLeft.png";
import CircleLeftBottom from "../images/EllipseRightBottom.png";
import HeroMainImage from "../images/hero-main.png";
import { useTranslation } from "react-i18next";

const HeroSection = ({ isMobileScreen }) => {
  const { t } = useTranslation();
  const navigate = useNavigate();

  return (
    <div className="thirdSection">
      <div className="login__section min-h-[750px] 2xl:min-h-[800px]">
        <img
          draggable="false"
          src={CircleRightTop}
          className="back_circle1"
          alt="back_circle1"
        />
        <img
          draggable="false"
          src={CircleLeftBottom}
          className="back_circle2"
          alt="back_circle2"
        />
        <div className="container px-2 mt-[100px] sm:mt-[110px] md-[50px] xl:max-w-[1000px] 3xl:max-w-[1400px]">
          <div className="container grid sm:grid-cols-1 lg:grid-cols-2 sm:gap-[0%] lg:gap-[0%]  sm:my-[30px] md:my-[40px] lg:my-[40px]">
            <div className="container px-2 sm:mt-[55px] md-[50px] xl:max-w-[1200px] 3xl:max-w-[1600px] mb-5">
              <button className="bug_bounty_button text-primaryButtonTextColor text-[14px] sm:text-[17px] font-[600] px-[10px] sm:px-[19px] py-[7px] sm:py-[12px] flex items-start border border-primaryButtonBorderColor mb-3">
                <img
                  draggable="false"
                  src={noteSearchImg}
                  className="w-[16px] sm:w-[22px] h-[24px] mr-[6px]"
                  alt="Arrow_up_small"
                />
                {t("omni_platform")}
              </button>
              <h1 className="text-[30px] sm:text-[34px] leading-[45px] sm:leading-[50px] md:leading-[58px] 3xl:leading-[80px] md:text-[36px] 3xl:text-[51px] font-[700] text-[#141619] capitalize">
                {t("unify")} {t("compliance")} {"data"}
              </h1>
              <h1
                className={`text-[30px] sm:text-[34px] leading-[45px] sm:leading-[50px] md:leading-[58px] 3xl:leading-[80px] md:text-[36px] 3xl:text-[51px] font-[700] ${
                  isMobileScreen
                    ? "text-primaryButtonTextColor"
                    : "text-[#141619]"
                }  capitalize`}
              >
                {t("streamline")} {t("compliance")} {t("reporting")}
              </h1>
              <p className="sora text-[#141619] md:text-[14px] lg:text-[13px] xl:text-[13px] text-[16px] sm:text-[16px] 3xl:text-[19px] font-[400] mt-3">
                {t("solutions_subtitle")}
              </p>
              <div
                className="requestDemoBtnOuter mt-[20px] sm:mt-[40px]"
                onClick={() => navigate("/contact-us")}
              >
                <Button className="sora requestDemoBtn">
                  {t("request_demo")}
                  <img
                    draggable="false"
                    src={arrow_btn}
                    className="w-[9px] sm:w-[12px] ml-[4px]"
                    alt="request demo"
                  />
                </Button>
              </div>
            </div>
            <div className="flex justify-center">
              <img
                draggable="false"
                src={HeroMainImage}
                className="sm:h-[350px] sm:w-[400px] lg:h-[480px] md:w-[390px] rounded-[10px] object-contain"
                alt="web3 security"
              />
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default HeroSection;
